import { render, staticRenderFns } from "./VQYesNo.vue?vue&type=template&id=e8bc1ba2&scoped=true"
import script from "./VQYesNo.vue?vue&type=script&lang=js"
export * from "./VQYesNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bc1ba2",
  null
  
)

export default component.exports